import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }
const _hoisted_2 = {
  class: "b-upload-avatar",
  style: {"width":"300px"}
}
const _hoisted_3 = { class: "b-upload-avatar__txt h-font-16 h-fw-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwAvatarUpload = _resolveComponent("FwAvatarUpload")!
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FwAvatarUpload, {
        backgroundImg: "",
        backgroundColor: "rgba(190,199,212,0.53)",
        uploadButton: true,
        iconImg: "no-avatar",
        titleTxt: _ctx.$t(`ONBOARDING.AVATAR.TITLE`),
        descriptionTxt: _ctx.$t(`ONBOARDING.AVATAR.DESCRIPTION`),
        descriptionTxtSuccess: _ctx.$t(`ONBOARDING.AVATAR.DESCRIPTION.SUCCESS`),
        buttonTxt: _ctx.$t(`ONBOARDING.AVATAR.IMPORT`),
        buttonTxtSuccess: _ctx.$t(`ONBOARDING.AVATAR.CONTINUE`),
        buttonUploadSuccess: _ctx.$t(`ONBOARDING.AVATAR.BUTTON.SUCCESS`),
        errorMessage: _ctx.$t(`ONBOARDING.AVATAR.ERROR.FILE.EXCEEDS`),
        isRequestSending: _ctx.isRequestSending,
        onUpload: _ctx.avatarUpload,
        onGoNextPage: _ctx.sendAvatarToServer
      }, null, 8, ["titleTxt", "descriptionTxt", "descriptionTxtSuccess", "buttonTxt", "buttonTxtSuccess", "buttonUploadSuccess", "errorMessage", "isRequestSending", "onUpload", "onGoNextPage"]),
      (!_ctx.avatarImage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "h-mt-20 h-flex h-flex-center h-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goNextPage && _ctx.goNextPage(...args)))
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`ONBOARDING.AVATAR.LATER`)), 1),
            _createVNode(_component_FwIcon, {
              class: "h-flex-center h-ml-20 h-pointer",
              icon: "arrow-right",
              size: "10",
              color: "rgba(33,63,107,.3)"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}